import { useTheme } from "@mui/material";
import { useRecipeModuleConfig } from "../../../../../OrderFlow/components/modules/Recipe/hooks/useRecipeModuleConfig";
import { tokenReplace } from "../../../../utils/tokenReplacement";
import { useCompanyConfigQuery } from "../../../../../SWR/Company/useCompanyConfigQuery";
import { getAddedMealsTextWhenAssigning, getAddedMealsTextWhenNotAssigning, getRemovedMealsText, getSelectedText, } from "./selectedXofYText-utils";
export const useSelectedXofYRecipesText = ({ programMealWithRecipes, sequenceNumber }) => {
    const theme = useTheme();
    const { noResultsAvailableText, enableAssignRecipes, enableAddMeals, enableRemoveMeals, moduleConfig } = useRecipeModuleConfig(sequenceNumber);
    const { tokenMap } = useCompanyConfigQuery();
    const replacedNoResultsAvailableText = tokenReplace(noResultsAvailableText, false, tokenMap);
    const recipesAvailable = (programMealWithRecipes === null || programMealWithRecipes === void 0 ? void 0 : programMealWithRecipes.recipesForMeal) && (programMealWithRecipes === null || programMealWithRecipes === void 0 ? void 0 : programMealWithRecipes.recipesForMeal.length) > 0;
    // === Destructure programMealWithRecipes and nested objects ===
    const { meal, assignmentsComplete = false, templateMealQuantity = 0, assignmentQuantityForMeal = 0, totalAddedMeals = 0, } = programMealWithRecipes !== null && programMealWithRecipes !== void 0 ? programMealWithRecipes : {};
    const { ProgramMealName: programMealName = "", Quantity: mealQuantity = 0, NumRemovedAssignments: numRemovedAssignments = 0, ProgramMealId: programMealId, } = meal !== null && meal !== void 0 ? meal : {};
    const textColor = assignmentsComplete ? theme.palette.success.main : theme.palette.text.primary;
    const selectedText = getSelectedText({
        mealQuantity,
        templateMealQuantity,
        assignmentQuantityForMeal,
        totalAddedMeals,
        moduleConfig,
    });
    const addedMealsTextWhenAssigning = getAddedMealsTextWhenAssigning({
        enableAddMeals,
        assignmentsComplete,
        assignmentQuantityForMeal,
        templateMealQuantity,
        totalAddedMeals,
        mealQuantity,
        moduleConfig,
    });
    const removedMealsText = getRemovedMealsText({
        enableRemoveMeals,
        numRemovedAssignments,
        moduleConfig,
    });
    const addedMealsTextWhenNotAssigning = getAddedMealsTextWhenNotAssigning({
        enableAddMeals,
        enableAssignRecipes,
        mealQuantity,
        templateMealQuantity,
        moduleConfig,
    });
    return {
        addedMealsTextWhenAssigning,
        addedMealsTextWhenNotAssigning,
        assignmentQuantityForMeal,
        enableAddMeals,
        enableAssignRecipes,
        enableRemoveMeals,
        hasMeal: !!meal,
        programMealId,
        programMealName,
        recipesAvailable,
        removedMealsText,
        replacedNoResultsAvailableText,
        selectedText,
        templateMealQuantity,
        textColor,
    };
};
